import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit,Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { AddCalanderComponent } from './add-calander/add-calander.component';
import {LabourService} from '../service/labour.service'
import { SharedService } from 'app/modules/common/services/shared-service';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';

interface LabourNode {
  comunidad: string;
  poblacion?: string;
  nodeId?:number;
  children?: LabourNode[];
}

interface ExampleFlatNode {
  expandable: boolean;
  comunidad: string;
  level: number;
}

@Component({
    selector: 'app-holiday-list',
    templateUrl: './holiday-list.component.html',
    styleUrls: ['./holiday-list.component.scss'],
    standalone: false
})
export class HolidayListComponent implements OnInit {
  @Output() treeViewData = new EventEmitter<any>();
  treeData :any;
  
  constructor(
    private dialog: MatDialog,
    private labourService: LabourService,
    private sharedService: SharedService
    ) {
  }

  ngOnInit(): void {
    this.loadTreeView(0);
  }

  private _transformer = (node: LabourNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      comunidad: node.comunidad,
      poblacion: node.poblacion,
      nodeId: node.nodeId,
      level: level,
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl,this.treeFlattener);


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  public loadTreeView(nodeId:number) {
    this.labourService.getLabourTreeView().subscribe(res => {
      if (res) {
        this.treeData = res;
        this.dataSource.data = this.treeData;
        this.treeControl.expand(this.treeControl.dataNodes[0]);
      }
    });
  }
  
  treeViewClick(node: any): void {    
    this.treeViewData.emit(node);
    console.log(node)
  }

  public openServiceAddEdit(data: any): void {
    const modalRef = this.dialog.open(AddCalanderComponent, { data: data });
    modalRef.afterClosed().subscribe(res => {
      this.loadTreeView(res);
      
    });
  }

  deletePoblacion(node:any)
  {
    const dialogDatacopiar = new ConfirmDialogModel('¿Eliminar el calendario laboral?', '');
    const dialogRefcopiar = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogDatacopiar
    });
    dialogRefcopiar.afterClosed().subscribe(res => {
      if(res){
        this.labourService.deletePoblacion(node).subscribe(resp=>{
          if(resp.result==0)
          {
            this.sharedService.ShowSnackBar('Eliminado correctamente', 'Okay', 2000);
            this.loadTreeView(0);
          }
        }, err => {
          console.error(err);
        })
      }
    });
  }

  
}
